var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-testid":"spentOnlyPane"}},[_c('gl-sprintf',{attrs:{"message":_vm.$options.timeSpent},scopedSlots:_vm._u([{key:"spent",fn:function(ref){
var content = ref.content;
return [_c('span',{staticClass:"gl-font-weight-bold"},[_vm._v(_vm._s(content))]),_vm._v(_vm._s(_vm.timeSpentHumanReadable)+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }